import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  name
  hubSpotValue
  subRegion
  address
  description
  websiteUrl
  imageUrl
  hashId
  status
  modelsCount
  enableNavigation
  enableMakeOffer
  salesContactName
  salesAddress
  externalId
  company {
    id
    name
  }
  productTypes {
    id
  }
  city {
    id
    name
    state
  }
  enableLotMapIntegration
  enableInventoryInsights
  lotMapSettings {
    provider
    lotWorks {
      mapUrl
      communityId
      displaySpecHomes
    }
    focus360 {
      communityId
    }
    streetscape {
      propertyId
      builderId
      mapKeys
      hideLotPrice
      displaySpecHomes
    }
  }
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
  sendGridContactLists
  division {
    id
    name
  }
  publishedListingsCount
  timezone
`;

const liteFragment = `
  id
  name
  imageUrl
`;

export const listCommunitiesQuery = `
  query ListCommunities(
    $filter: CommunityFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listCommunities(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const listCommunitiesLiteQuery = `
  query ListCommunitiesLite(
    $filter: CommunityFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listCommunities(
      filter: $filter
      sort: $sort
      page: $page
      pageSize: $pageSize
    ) {
      items {
        ${liteFragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getCommunityQuery = `
  query GetCommunity($id: Int!) {
    item: getCommunity(id: $id) {
      ${fragment}
    }
  }
`;

export const getCommunityInventoryInsightsQuery = `
  query GetCommunityInventoryInsights($id: Int!) {
    inventoryInsights: getCommunityInventoryInsights(id: $id) {
      publishedListingsCount
      reservationsCount
    }
  }
`;

export const createCommunityMutation = `
  mutation CreateCommunity(
    $input: CreateCommunityInput!
    $image: Upload
  ) {
    item: createCommunity(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateCommunityMutation = `
  mutation UpdateCommunity(
    $input: UpdateCommunityInput!
    $image: Upload
  ) {
    item: updateCommunity(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteCommunityQuery = `
  mutation DeleteCommunity(
    $id: Int!
  ) {
    item: deleteCommunity(id: $id) {
      ${fragment}
    }
  }
`;

export const cloneCommunityQuery = `
  mutation CloneCommunity(
    $id: Int!
  ) {
    item: cloneCommunity(id: $id) {
      ${fragment}
    }
  }
`;

export const updateCommunityStatusQuery = `
  mutation UpdateCommunityStatus(
    $input: UpdateCommunityStatusInput!
  ) {
    item: updateCommunityStatus(input: $input) {
      ${fragment}
    }
  }
`;

export const listCommunityAdminsQuery = `
  query ListCommunityAdmins($id: Int!) {
    items: listCommunityAdmins(id: $id) {
      id
      name
      email
      phones
      role
    }
  }
`;
